"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgEdit(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M29.013 9.96a3.355 3.355 0 00-4.675-.079L10.627 22.76a3.355 3.355 0 00-.971 1.686l-1.207 5.192a1.677 1.677 0 001.938 2.03l5.505-1.016a3.355 3.355 0 001.681-.848l13.633-12.735a3.355 3.355 0 00.087-4.819l-2.28-2.29z", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M16.656 28.344l-5-5", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }, void 0)] }), void 0));
}
exports.default = SvgEdit;
//# sourceMappingURL=Edit.js.map